import { Injectable } from "@angular/core";
import { EntityService } from "./entity.service";
import { JQueryHTTPClient } from "./JQueryHTTPClient";
import { Rest } from "./rest_client";

@Injectable()
export class ZonegroupService extends EntityService<Rest.ZoneGroup> {
  client: Rest.RestApplicationClient;
  constructor(private jquery: JQueryHTTPClient) {
    super();
    this.client = new Rest.RestApplicationClient(jquery);
  }

  create(arg0: Rest.ZoneGroup): Rest.RestResponse<Rest.ZoneGroup> {
    return this.client.ZoneGroup_create(arg0);
  }

  update(arg0: Rest.ZoneGroup): Rest.RestResponse<Rest.ZoneGroup> {
    return this.client.ZoneGroup_update(arg0);
  }

  findAll(arg0: number[]): Rest.RestResponse<Rest.ZoneGroup[]> {
    return this.client.ZoneGroup_findAll(arg0);
  }

  getPage(
    arg0: Rest.ListPaginationRequest
  ): Rest.RestResponse<Rest.Page<Rest.ZoneGroup>> {
    return this.client.ZoneGroup_getPage(arg0);
  }

  getPageAndFilters(
    arg0: Rest.ListPaginationRequest
  ): Rest.RestResponse<Rest.ListPageAndFilters<Rest.ZoneGroup>> {
    return this.client.ZoneGroup_getPageAndFilters(arg0);
  }

  changeStatus(
    arg0: number[],
    queryParams?: { status?: boolean }
  ): Rest.RestResponse<void> {
    return this.client.ZoneGroup_changeStatus(arg0, queryParams);
  }

  // @ts-ignore
  find(
    arg0: string,
    queryParams?: { id?: number }
  ): Rest.RestResponse<Rest.ZoneGroup> {
    return this.client.ZoneGroup_find(arg0, queryParams);
  }
}
